import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-checkbox',
  imports: [NgClass, SvgComponent],
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {
  checked = model(false);
}
